import React from 'react';

import type1 from '../../../assets/allConnectorsPng/type1.png';
import type2 from '../../../assets/allConnectorsPng/type2.png';
import ccstype1 from '../../../assets/allConnectorsPng/ccstype1.png';
import ccstype2 from '../../../assets/allConnectorsPng/ccstype2.png';
import tesla from '../../../assets/allConnectorsPng/tesla.png';
import chademo from '../../../assets/allConnectorsPng/chademo.png';
import gbtdc from '../../../assets/allConnectorsPng/gbTDTC.png';
import gbtac from '../../../assets/allConnectorsPng/gbTAC.png';
import plugNBR from '../../../assets/plug-nbr.png';
import { T } from 'react-translator-component';

export const CONNECTORS = {
  'Type 1': (
    <img src={type1} alt='conector' className='colored_connector_icons' />
  ),
  'Type 2': (
    <img src={type2} alt='conector' className='colored_connector_icons' />
  ),
  Tesla: <img src={tesla} alt='conector' className='colored_connector_icons' />,
  'CCS Type 1': (
    <img src={ccstype1} alt='conector' className='colored_connector_icons' />
  ),
  'CCS Type 2': (
    <img src={ccstype2} alt='conector' className='colored_connector_icons' />
  ),
  CHAdeMO: (
    <img src={chademo} alt='conector' className='colored_connector_icons' />
  ),
  'GB/T DC': (
    <img src={gbtdc} alt='conector' className='colored_connector_icons' />
  ),
  'GB/T AC': (
    <img src={gbtac} alt='conector' className='colored_connector_icons' />
  ),
  'Plug NBR': (
    <img src={plugNBR} alt='conector' className='colored_connector_icons' />
  ),
};

export const COLORS = {
  available: '#02FF3A',
  busy: '#FD8900',
  unavailable: '#e1e1e1',
  maintenance: '#28467d',
  black: '#000000',
  faulted: '#fd4f4f',
  groupFull: '#e1e1e1',
};

export const BG_COLORS = {
  ...COLORS,
  maintenance: '#e1e1e1',
  faulted: '#fd4f4f',
};

export const CONNECTORS_STATUS_TRANSLATED = {
  available: T('Available'),
  busy: T('Busy'),
  unavailable: T('Unavailable'),
  maintenance: T('Maintenance'),
  faulted: T('Faulted'),
  groupFull: T('Charging group full'),
};

export const showTooltip = (e) => {
  return e.currentTarget
    .querySelector('.colored_connector_tooltip')
    ?.classList.add('show');
};

export const hideTooltip = (e) => {
  return e.currentTarget
    .querySelector('.colored_connector_tooltip')
    ?.classList.remove('show');
};
